var m = require('mithril');
var prop = require('mithril/stream');
var treeEquipment = require('../locations/treeEquipment');

var nextInputId = 1;

function normalizeSingleRid(rawValue) {
  var trimmed = '';
  if (rawValue !== null && typeof rawValue !== 'undefined') {
    trimmed = String(rawValue).trim();
  }
  if (!trimmed) {
    return { normalized: null, hasValue: false, valid: true };
  }
  var prefixed = trimmed.charAt(0) === '#' ? trimmed : ('#' + trimmed);
  var valid = /^#\d+:\d+$/.test(prefixed);
  return { normalized: valid ? prefixed : null, hasValue: true, valid: valid };
}

function streamValue(stream) {
  return typeof stream === 'function' ? stream() : stream;
}

function setStreamValue(stream, value) {
  if (typeof stream === 'function') {
    stream(value);
  }
}

function pushError(errors, message) {
  if (!message) return;
  if (Array.isArray(errors)) {
    errors.push(message);
  }
}

function formatLocationSelectionPath(record) {
  if (!record) {
    return '';
  }
  if (record._pathLabel) {
    return record._pathLabel;
  }
  if (typeof record.path === 'string') {
    return record.path;
  }
  if (Array.isArray(record.path)) {
    return record.path.map(function (pathRecord) {
      if (!pathRecord) return '';
      if (pathRecord.name === 'root') return 'Home';
      return pathRecord.roomNumber
        ? ((pathRecord.name || pathRecord['@class'] || '') + ' ' + pathRecord.roomNumber).trim()
        : (pathRecord.name || pathRecord['@class'] || '');
    }).filter(Boolean).join(' / ');
  }
  return record.name || record['@class'] || record['@rid'] || '';
}

function handleKeyboardAction(ev, action) {
  if (ev.key !== 'Enter' && ev.key !== ' ') {
    return;
  }
  ev.preventDefault();
  action(ev);
}

function renderFieldLabel(label, inputId) {
  if (!label) {
    return null;
  }
  return m('div.element-field-label', [
    m('name', { for: inputId }, label)
  ]);
}

function renderButtonContent(iconClass, text, pathTitle) {
  return m('span.equipment-selection-button-content', [
    iconClass ? m('i.mr1.' + iconClass) : null,
    m('span.equipment-selection-button-label' + (pathTitle ? '.is-path' : ''), pathTitle ? {
      title: pathTitle
    } : {}, text)
  ]);
}

function renderLocalButton(className, children, action) {
  return m('div.f4.ba.bw1.ph3.pv2.tc.v-btm.' + className, {
    onclick: action,
    onkeydown: function (ev) {
      handleKeyboardAction(ev, action);
    },
    role: 'button',
    tabindex: 0
  }, children);
}

module.exports = {
  oninit: function (vnode) {
    this.showTree = false;
    this.selectedNode = prop(null);
    this.inputId = vnode.attrs.inputId || ('location-selector-input-' + nextInputId++);
  },

  view: function (vnode) {
    var ctrl = this;
    var attrs = vnode.attrs || {};
    var currentValue = streamValue(attrs.value);
    var selectedLocation = ctrl.selectedNode && ctrl.selectedNode();
    var selectedLocationRid = selectedLocation && selectedLocation['@rid'];
    var selectedLocationPath = formatLocationSelectionPath(selectedLocation);
    var buttonUsesPath = !!(
      selectedLocationPath &&
      !ctrl.showTree &&
      currentValue === selectedLocationRid
    );
    var toggleText = buttonUsesPath
      ? selectedLocationPath
      : ctrl.showTree ? 'Cancel' : 'Select Location';
    var inputId = attrs.inputId || ctrl.inputId;
    var invalidMessage = attrs.invalidMessage || 'Invalid format for location Rid. Please use the format "#<clusterId>:<recordId>"';

    function toggleTree() {
      ctrl.showTree = !ctrl.showTree;
    }

    function confirmSelection() {
      var chosen = ctrl.selectedNode();
      if (chosen && chosen['@rid']) {
        setStreamValue(attrs.value, chosen['@rid']);
        ctrl.showTree = false;
        if (typeof attrs.onselect === 'function') {
          attrs.onselect(chosen);
        }
      } else {
        pushError(attrs.errors, attrs.requiredSelectionMessage);
      }
    }

    return m('div', {
      class: 'form-group mb2 equipment-selector location-selector' + (ctrl.showTree ? ' is-expanded' : '') + (attrs.class ? (' ' + attrs.class) : '')
    }, [
      typeof attrs.renderLabel === 'function'
        ? attrs.renderLabel(inputId)
        : renderFieldLabel(attrs.label, inputId),
      m('div.equipment-selector-row', [
        m('div.equipment-selector-action', [
          renderLocalButton('blue.equipment-selection-toggle-button', [
            renderButtonContent(
              'blue.' + (ctrl.showTree ? 'ion-close' : 'ion-chevron-down'),
              toggleText,
              buttonUsesPath ? selectedLocationPath : null
            )
          ], toggleTree)
        ]),
        m('input.form-control.equipment-selector-rid', {
          id: inputId,
          type: 'text',
          autocomplete: 'off',
          placeholder: attrs.placeholder || '#<clusterId>:<recordId>',
          oninput: function (ev) {
            setStreamValue(attrs.value, ev.target.value);
            ctrl.selectedNode(null);
          },
          onblur: function (ev) {
            var nextState = normalizeSingleRid(ev.target.value);
            if (!nextState.hasValue) {
              setStreamValue(attrs.value, null);
              ev.target.value = '';
              return;
            }
            if (!nextState.valid) {
              pushError(attrs.errors, invalidMessage);
              return;
            }
            setStreamValue(attrs.value, nextState.normalized);
            ev.target.value = nextState.normalized;
          },
          value: currentValue || '',
        })
      ]),

      ctrl.showTree && m('div.equipment-selector-tree.mb2', [
        m(treeEquipment, {
          initialRid: currentValue,
          selectedNode: ctrl.selectedNode,
          selectionType: 'location'
        }),
        m('div.w-100.cf', {
          style: { visibility: ctrl.selectedNode() ? 'visible' : 'hidden' }
        }, [
          renderLocalButton('fr.green.mv2.equipment-selection-confirm-button', 'Select Location', confirmSelection)
        ])
      ])
    ]);
  }
};
